import kformBuilderUtils from '../../utils/kform-builder.utils';

const kformBuilderOptionShortcutController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.shortcuts = kformBuilderUtils.getAvailableShortcuts($scope.form, $scope.component);
};

export default kformBuilderOptionShortcutController;
